import { CheckCircle2, ListOrdered } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const QuoteCrudMessage = ({
  content,
}: {
  content: {
    message?: string
    action?: string
    success?: boolean
    data?: {
      items?: Array<{
        id: number
        description?: string | null
        quantity?: number | null
      }>
    }
  }
}) => {
  const { t } = useLocalization()
  const items = content.data?.items ?? []

  return (
    <Column className="gap-2 rounded-lg border border-violet-200 bg-violet-50 px-3 py-2">
      <Row className="items-center gap-2">
        {content.action === 'list_order' ? (
          <ListOrdered className="h-4 w-4 text-violet-700" />
        ) : (
          <CheckCircle2 className="h-4 w-4 text-violet-700" />
        )}
        <p className="text-sm text-violet-900">{t(content.message)}</p>
      </Row>

      {content.action === 'list_order' && items.length > 0 && (
        <Column className="gap-1 pl-6">
          {items.map((item) => (
            <p key={item.id} className="text-sm text-violet-800">
              {t(item.description ?? '') || t('Item', 'Rad')} ·{' '}
              {item.quantity ?? 1} {t('pcs', 'st')}
            </p>
          ))}
        </Column>
      )}
    </Column>
  )
}
